export default {
  api: {
    list: {
      method: "get",
      url: "/user/order/list"
    },
    pay: {
      method: "post",
      url: "/user/order/pay/{orderNo}"
    },
    checkFirstOrder: {
      method: "get",
      url: "/user/order/checkFirstOrder"
    },
    info: {
      method: "get",
      url: "/user/order/{orderNo}"
    },
    buy: {
      method: "post",
      url: "/user/order/pay"
    },
    close: {
      method: "put",
      url: "/user/order/close/{orderNo}"
    }
  }
};
